/**
 * @file `StatusPill` — operator-tool status lozenge.
 * @module @labcraft/admin/ui/learners/status-pill
 *
 * One className per status (`pill--inactive` etc.); the actual
 * colors come from `--op-status-<status>-{bg|fg}` tokens defined in
 * `learners.css`.
 */

import type { JSX } from 'react'
import type { LearnerStatus } from '../../shared/routes.ts'

/** Render a status pill for a learner. */
export function StatusPill({ status }: { status: LearnerStatus }): JSX.Element {
  return <span className={`pill pill--${status}`}>{status}</span>
}
